import { Component, computed } from '@angular/core';
import { environment } from '../../../../../environments/environment';

@Component({
  selector: 'app-recursos',
  imports: [],
  templateUrl: './recursos.html',
  styleUrl: './recursos.scss',
})
export class Recursos {
  readonly downloadsBaseUrl = `${environment.downloadsBaseUrl}/${environment.impresionDocumentosUrl}`;

  readonly repartidorUrl = computed(() => {
    //let url = window.location.origin;
    let hostName = window.location.hostname;
    let index = hostName.indexOf('.');
    let subDomanin = hostName.substring(0, index) + ".pw";
    hostName = hostName.substring(index + 1);
    let url = `${window.location.protocol}//${subDomanin}.${hostName}:${window.location.port}/repartidor/repartir`;
    return url;
  });

  copyRepartidorUrl() {
    void navigator.clipboard.writeText(this.repartidorUrl());
  }
}
